// extracted by mini-css-extract-plugin
export default {"Container":"chart_Container__O7McD","chat-wrapper":"chart_chat-wrapper__FDbz0","chart":"chart_chart__f8H5C","details":"chart_details__E99KI"};